import React, { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './ManageEmployees.css';
import { useTranslation } from 'react-i18next';

const ManageEmployees = () => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState([]);
  const [employeeName, setEmployeeName] = useState('');
  const [coffeeShopId, setCoffeeShopId] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const id = localStorage.getItem('coffee_shop_id');
    if (id) {
      setCoffeeShopId(id);
      fetchEmployees(id);
    }
  }, []);

  const fetchEmployees = async (shopId) => {
    try {
      const q = query(collection(db, 'employees'), where('coffee_shop_id', '==', shopId));
      const snapshot = await getDocs(q);
      setEmployees(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error('❌ Failed to fetch employees:', error);
    }
  };

  const addEmployee = async () => {
    if (!employeeName || !coffeeShopId) return;
    await addDoc(collection(db, 'employees'), {
      name: employeeName,
      coffee_shop_id: coffeeShopId,
    });
    setEmployeeName('');
    fetchEmployees(coffeeShopId);
  };

  const deleteEmployee = async (id) => {
    await deleteDoc(doc(db, 'employees', id));
    fetchEmployees(coffeeShopId);
  };

  return (
    <div className="manage-employees-container">
      <h2>👥 {t('manage_employees')}</h2>

      <div className="add-employee-section">
        <input
          type="text"
          placeholder={t('employee_name')}
          value={employeeName}
          onChange={(e) => setEmployeeName(e.target.value)}
        />
        <button onClick={addEmployee}>➕ {t('add_employee')}</button>
      </div>

      <ul className="employee-list">
        {employees.map((emp) => (
          <li key={emp.id}>
            {emp.name}
            <button className="delete-btn" onClick={() => deleteEmployee(emp.id)}>🗑️</button>
          </li>
        ))}
      </ul>

      <button className="dashboard-btn" onClick={() => navigate('/dashboard')}>
        🔙 {t('back_dashboard')}
      </button>
    </div>
  );
};

export default ManageEmployees;